// extracted by mini-css-extract-plugin
export default {"Box":"slicer-panel-resizer-module__Box--Jndg3","Box_1":"slicer-panel-resizer-module__Box_1--FQm1h","isDragging":"slicer-panel-resizer-module__isDragging--OWe3Q"};